var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9524 16.9848L1.01514 7.04756L5.27544 6.33665L10.597 1.01514L16.9848 7.40302L11.6633 12.7245L10.9524 16.9848ZM5.98635 12.0188L1.37059 16.6294L5.98635 12.0188Z",
    fill: "#CBD6E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.98635 12.0188L1.37059 16.6294M10.9524 16.9848L1.01514 7.04756L5.27544 6.33665L10.597 1.01514L16.9848 7.40302L11.6633 12.7245L10.9524 16.9848Z",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.e10ad9b9c270e7ca73f1684491d39f81.svg";
export { ForwardRef as ReactComponent };